import { io } from 'socket.io-client';
import type { Socket } from 'socket.io-client';
import type { SessionEventDataMap } from 'bc-model';
import { logoutUser } from './api';
import getApiVersion from './apiVersion';
import { includeBasePath } from '../utils/url-utils';
import { IS_GOTENBERG_PRINTING } from '../utils';

type SocketCallback = (arg: any) => void;
type ListenEvents = {
  [K in keyof SessionEventDataMap]: undefined extends SessionEventDataMap[K]
    ? (...args: [SessionEventDataMap[K]?, SocketCallback?]) => void
    : (...args: [SessionEventDataMap[K], SocketCallback?]) => void;
};

type TypedSocket = Socket<ListenEvents>;

const socket = io('', {
  path: includeBasePath(`/socket.io`),
  withCredentials: true,
  // Disable the socket when printing which doesn't require updates to artifacts
  autoConnect: !IS_GOTENBERG_PRINTING,
  auth: {
    apiVersion: getApiVersion(),
  },
}) as TypedSocket;

socket.on('logout', ({ reason }) => {
  logoutUser(reason);
});

socket.on('server:rebalance', () => {
  void fetch(includeBasePath('/api/rebalance'), { credentials: 'include' })
    .finally(() => {
      socket.disconnect();
      socket.connect();
    })
    .catch(() => {});
});

export type { ListenEvents, TypedSocket };
export { socket };
